module.exports = __webpack_public_path__ + "img/9d1595f738f7a339e789d060bd40c52e.png";